<template>
    <ContainerContent
        class="mb-16 mt-4"
        max-class="max-w-lg-ceil"
        outer-container
    >
        <v-row>
            <v-col>
                <h1 class="page-title">Store Locator</h1>
            </v-col>
        </v-row>
        <v-row>
            <v-col
                class="d-flex flex-column"
            >
                <StoreLocator></StoreLocator>
            </v-col>
        </v-row>
    </ContainerContent>
</template>

<script lang="ts" setup>
    import StoreLocator from '~/components/retail/StoreLocator/StoreLocator.vue';
    import ContainerContent from '~/components/ContainerContent/ContainerContent.vue';

    definePageMeta({
        scrollToTop: true,
        alias: [
            '/retailers/stores'
        ]
    });

    const $config = useRuntimeConfig();
    const brandTitle = $config.public.brand.title;

    useHead({
        title: `Store Locator | ${brandTitle}`,
        meta: [
            {
                name: 'description',
                content: 'Store Locator'
            }
        ]
    });
</script>

<style lang="scss" scoped></style>
